<template>
  <div>
    <div v-if="item.teaching" class="pt-2" :class="{ 'px-3': $vuetify.breakpoint.mdAndUp }">
      <Breadcrumbs
        :class="{ 'px-5 mt-2': $vuetify.breakpoint.smAndDown }"
        data="item.teaching.class.title"
        :headline="`Kế hoạch giảng dạy`"
        :link="[
          { text: 'Kế hoạch giảng dạy', href: '../teaching-plan' },
          { text: `Lớp ${item.teaching.class.title} - ${item.teaching.subject.title}`, id: item.teaching.id },
        ]"
      />
      <v-card class="d-flex justify-space-between align-center my-4 pa-5 border" outlined>
        <v-row no-gutters>
          <v-col cols="12" md="1">
            <span>Khối</span>
            <h4 class="font-weight-bold">{{ item.teaching.grade.title || '—' }}</h4>
          </v-col>
          <v-col cols="12" md="1">
            <span>Lớp</span>
            <h4 class="font-weight-bold">{{ item.teaching.class.title || '—' }}</h4>
          </v-col>
          <v-col cols="12" md="2">
            <span>Môn học</span>
            <h4 class="font-weight-bold">{{ item.teaching.subject.title || '—' }}</h4>
          </v-col>
          <v-col cols="12" md="3">
            <span>Giáo viên phụ trách</span>
            <h4 class="font-weight-bold">{{ item.teaching.teacher ? item.teaching.teacher.name : '—' }}</h4>
          </v-col>
          <v-col cols="12" md="3">
            <span>Cập nhật lần cuối</span>
            <h4 class="font-weight-bold">
              {{ new Date(item.teaching.updatedAt).toLocaleDateString('vi-VN') }}, lúc
              {{
                new Date(item.teaching.updatedAt).toLocaleTimeString('vi-VN', {
                  hour: '2-digit',
                  minute: '2-digit',
                })
              }}
            </h4>
          </v-col>
          <v-col cols="12" md="2">
            <div>Trạng thái</div>
            <v-chip
              v-if="item.plan"
              small
              class="white--text"
              :color="item.plan.status | teachingPlanStatusColor"
              label
            >
              {{ item.plan.status | teachingPlanStatus }}
            </v-chip>
            <v-chip v-else small style="background-color: #e6e4eb; color: #9c9c9c" label> Chưa có thông tin </v-chip>
          </v-col>
        </v-row>
      </v-card>
      <DetailTabs class="mt-8" />
    </div>
    <h1 v-else-if="!$loading.active">Teaching plan not found</h1>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'
import DetailTabs from './DetailTabs.vue'

export default {
  components: {
    Breadcrumbs,
    DetailTabs,
  },
  computed: {
    ...mapGetters('TeachingPlan', ['item']),
  },
  methods: {
    ...mapActions('TeachingPlan', ['fetchOne']),
  },
  async created() {
    this.$loading.active = true
    await this.fetchOne(this.$route.params.id)
    this.$loading.active = false
  },
}
</script>
<style scoped>
.theme--light.v-tabs-items {
  background-color: transparent;
}
td {
  padding-top: 4px;
}
td:first-child {
  padding-right: 48px;
}
</style>
